import ViewUserBasicDetailsContainer from "./ViewUserBasicDetailsContainer";

export default ViewUserBasicDetailsContainer;
